import tippy from "tippy.js";
import cash from "cash-dom";

(function () {
    let selection = cash("[data-tooltip]");
    if (selection.length) {
        selection.each(function (i, element) {
            let content = `<div class="inline-flex">${element.dataset.tooltip}</div>`;
            tippy(element, {
                content: content,
                allowHTML: true
            })
        })
    }
})
();